module.exports = __webpack_public_path__ + "img/logo_9.98ba9f27.png";